import { createAsyncThunk } from '@reduxjs/toolkit';

import VerificationProcessApi from 'api/curo/VerificationProcessApi';
import { VerificationProcessActionType } from 'enums/curo/VerificationProcessActionType';
import rejectWithValueHelper from 'utils/rejectWithValueHelper';

export const createVerifyPhoneVerificationCodeThunk = (api: VerificationProcessApi) =>
  createAsyncThunk(
    VerificationProcessActionType.VerifyPhoneVerificationCode,
    async ({ applicationId, code }: { applicationId: string; code: string }, thunkApi) => {
      try {
        const response = await api.verifyPhoneVerificationCode(applicationId, code);
        return response;
      } catch (error) {
        return rejectWithValueHelper(error as Error, thunkApi);
      }
    },
  );
